import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-enter",
  "use": "arrow-enter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-enter\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 1.5a.5.5 0 01.5.5v9.5a.5.5 0 01-.5.5H4a.5.5 0 010-1h8.5V2a.5.5 0 01.5-.5z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.82 8.116a.5.5 0 01.064.704L3.651 11.5l2.233 2.68a.5.5 0 01-.768.64l-2.5-3a.5.5 0 010-.64l2.5-3a.5.5 0 01.704-.064z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol